var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 545,
    viewBox: "0 0 420 545",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3847_2098",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 420,
    height: 545
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 419.5,
    height: 544.5,
    rx: 26.75,
    fill: "#2A2A2A",
    stroke: "#A1A1A1",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3847_2098)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3847_2098)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 368.281,
    cy: 81.9718,
    rx: 126,
    ry: 197.175,
    fill: "#8D19DA"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3847_2098",
    x: -21.7188,
    y: -379.203,
    width: 780,
    height: 922.352,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 132,
    result: "effect1_foregroundBlur_3847_2098"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactbg);
export default __webpack_public_path__ + "static/media/contactbg.d756fa8c21e80ee317ff825d6bcaf4cb.svg";
export { ForwardRef as ReactComponent };